/**
 * `/v1/meta` in local mode (plan §6.6).
 *
 * Every ingest-derived field is null, and that is the honest answer rather than
 * a placeholder: local mode has no ingest, so there is no snapshot date, no last
 * run and no membership as-of. Substituting "today" would make the SPA's
 * staleness banner report freshness it cannot possibly know.
 *
 * `dataSource: 'synthetic'` is a SAFETY classification, not a vendor name — the
 * web shell renders a permanent non-dismissible SYNTHETIC DATA banner off it,
 * and a production build refuses to boot against it (plan §6.6 · §1.1 rule 4).
 */
import { SECTOR_IDS, INDEX_CODES, WINDOW_KEYS, type DatasetMeta } from '@meridian/contracts';

import { SECN } from '../../constants/sectors';

import type { DerivedSecurity } from '../../universe/derive-security';

export function buildMeta(rows: readonly DerivedSecurity[]): DatasetMeta {
  return {
    dataSource: 'synthetic',
    /* Never a literal — plan §3.3 bans a hard-coded universe count. */
    universeSize: rows.length,
    asOf: null,
    windows: [...WINDOW_KEYS],
    indices: [...INDEX_CODES],
    sectors: SECTOR_IDS.map((id) => ({ id, name: SECN[id] })),
    lastIngestAt: null,
    lastDataAdvancedOn: null,
    lastOperationalTradingDay: null,
    membershipAsOf: null,
  };
}
